"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentDocPaymentGroupsNowPaymentDates = void 0;
const typeorm_1 = require("typeorm/browser");
let PaymentDocPaymentGroupsNowPaymentDates = class PaymentDocPaymentGroupsNowPaymentDates {
};
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'delta_based_on_groups' }),
    __metadata("design:type", Number)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "deltaBasedOnGroups", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'grouped_line_items_total_gross' }),
    __metadata("design:type", Number)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "groupedLineItemsTotalGross", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'payments_total' }),
    __metadata("design:type", Number)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "paymentsTotal", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'payments_dates' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "paymentsDates", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'payment_total' }),
    __metadata("design:type", Number)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "paymentTotal", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'pr_id' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "prId", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'pr_reference_number' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "prReferenceNumber", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'pr_reference_text' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "prReferenceText", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'pr_date' }),
    __metadata("design:type", Date)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "prDate", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_name' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountName", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_firstname' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountFirstname", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_lastname' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountLastname", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_billing_street' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountBillingStreet", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_billing_postal_code' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountBillingPostalCode", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_billing_city' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountBillingCity", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_billing_country' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountBillingCountry", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_shipping_street' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountShippingStreet", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_shipping_postal_code' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountShippingPostalCode", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_shipping_city' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountShippingCity", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_shipping_country' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountShippingCountry", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_email_for_invoices' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountEmailForInvoices", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_type' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountType", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_sfid' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "accountSfid", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'supposed_document_status' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "supposedDocumentStatus", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'doc_numbers' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "docNumbers", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'doc_issue_date_max' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "docIssueDateMax", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'doc_lineitems_deliverydate_max' }),
    __metadata("design:type", String)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "docLineitemsDeliverydateMax", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'doc_count' }),
    __metadata("design:type", Number)
], PaymentDocPaymentGroupsNowPaymentDates.prototype, "docCount", void 0);
PaymentDocPaymentGroupsNowPaymentDates = __decorate([
    (0, typeorm_1.ViewEntity)({
        name: 'payment_doc_payment_groups_now_payment_dates',
        schema: 'analytics',
        materialized: true,
        expression: `
    select
    *
    from
    (
        select
        (
            (case when grouplinked_line_item_total_gross->'volume'::text = 'null' then 0.0::decimal else (grouplinked_line_item_total_gross->'volume')::numeric end)
            - (case when grouplinked_payments_totals->'total'::text = 'null' then 0.0::decimal else (grouplinked_payments_totals->'total')::numeric end)
        ) as delta_based_on_groups,
        (case when grouplinked_line_item_total_gross->'volume'::text = 'null' then 0.0::decimal else (grouplinked_line_item_total_gross->'volume')::numeric end) as grouped_line_items_total_gross,
        (case when grouplinked_payments_totals->'total'::text = 'null' then 0.0::decimal else (grouplinked_payments_totals->'total')::numeric end) as payments_total,

        (case when grouplinked_payments_totals->'payment_date'::text = 'null' then '' else (grouplinked_payments_totals->'payment_date')::text end)  as payments_dates,
        pr_total_amount as payment_total,
        pr_id,
        pr_reference_number,
        pr_reference_text,
        pr_date,
        account_name,
        account_firstname,
        account_lastname,
        account_billing_street,
        account_billing_postal_code,
        account_billing_city,
        account_billing_country,
        account_shipping_street,
        account_shipping_postal_code,
        account_shipping_city,
        account_shipping_country,
        account_email_for_invoices,
        account_type,
        account_sfid,
        case
            when (
                abs(
                    (
                        case
                            when grouplinked_line_item_total_gross->'volume'::text = 'null'
                            then 0.0::decimal
                            else (case when grouplinked_line_item_total_gross->'volume'::text = 'null' then 0.0::decimal else (grouplinked_line_item_total_gross->'volume')::numeric end)
                        end
                    )
                ) <=
                (
                    abs(
                        case
                            when grouplinked_payments_totals->'total'::text = 'null'
                            then 0.0::decimal
                            else (case when grouplinked_payments_totals->'total'::text = 'null' then 0.0::decimal else (grouplinked_payments_totals->'total')::numeric end)
                        end
                    )
                +0.05
                )
                or
                grouplinked_line_item_total_gross->'volume'::text = 'null'
            ) then 'paid'
            when  abs(
                    (case when grouplinked_line_item_total_gross->'volume'::text = 'null' then 0.0::decimal else (grouplinked_line_item_total_gross->'volume')::numeric end)
                ) >  (
                    abs(
                        case
                            when grouplinked_payments_totals->'total'::text = 'null'
                            then 0.0::decimal
                            else (case when grouplinked_payments_totals->'total'::text = 'null' then 0.0::decimal else (grouplinked_payments_totals->'total')::numeric end)
                        end
                    )
                +0.05
                ) or
                grouplinked_payments_totals->'total'::text = 'null'
            then 'unpaid'
            else  'unknown'
        end as supposed_document_status,
        grouplinked_line_item_total_gross->>'doc_numbers' as doc_numbers,
        grouplinked_line_item_total_gross->>'max_issue_date' as doc_issue_date_max,
        grouplinked_line_item_total_gross->>'max_delivery_date' as doc_lineitems_deliverydate_max,
        jsonb_array_length( (grouplinked_line_item_total_gross->>'doc_numbers')::jsonb ) as doc_count

        from
        (
                select
                (
                    select
                    -- sum(line_volume)
                    jsonb_build_object(
                      'volume', sum(line_volume),
                      'doc_numbers', jsonb_agg(DISTINCT doc_number),
                      'max_issue_date', max(issue_date),
                  'max_delivery_date', max(delivery_date)
                    ) as doc
                    from
                    (
                        select
                        case
                            when doc.type = 'credit_note' and not doc.reverse_vat_charge then (-li.total_price*(100+li.vat_rate)/100)::numeric
                            when doc.type = 'credit_note' and doc.reverse_vat_charge     then (-li.total_price*(100)/100)::numeric
                            when doc.type = 'invoice' and not doc.reverse_vat_charge     then (li.total_price*(100+li.vat_rate)/100)::numeric
                            when doc.type = 'invoice' and doc.reverse_vat_charge         then (li.total_price*(100)/100)::numeric
                            else 0.0
                        end  as line_volume,
                        doc.number as doc_number,
                        doc.issue_date as issue_date,
                        li.delivery_date as delivery_date
                        from accounting.accounting_document doc
                        left join accounting.accounting_document_line_item li
                            on li.document_id = doc.id
                        where
                        true
                        and doc.status not in ('cancelled', 'cancellation_sent')
                        and doc.issue_date <= NOW()::date
                        and (
                            doc.id in  (
                              with recursive docpr as (
                                select
                                  accounting_document_id,
                                  payment_record_id
                                  ,
                                  jsonb_build_object('accounting_document_id', accounting_document_id, 'payment_record_id', payment_record_id ) as docprjson

                                from accounting.accounting_document_payments_payment_record -- adppr
                                where payment_record_id = pr_id
                                union
                                select
                                  adppr.accounting_document_id,
                                  adppr.payment_record_id
                                  ,
                                  jsonb_build_object('accounting_document_id', adppr.accounting_document_id, 'payment_record_id', adppr.payment_record_id ) as docprjson
                                from accounting.accounting_document_payments_payment_record adppr
                                    join docpr on
                                (	docpr.accounting_document_id = adppr.accounting_document_id
                                  or
                                  docpr.payment_record_id = adppr.payment_record_id
                                )
                              )
                              select
                                    accounting_document_id
                              from docpr
                            )
                        )
                        order by doc_number asc
                    ) as line_volumes
                ) as grouplinked_line_item_total_gross,

                (
                    select
                    *
                    from
                    (
                        select
                        jsonb_build_object(
                            'total', sum(pr.total),
                            'reference_texts', jsonb_agg(reference_text),
                            'payment_date', jsonb_agg(date)
                        ) as doc
                        from
                        payment.payment_record pr
                        where pr.id in
                        (
                          with recursive docpr as (
                            select
                              accounting_document_id,
                              payment_record_id
                              ,
                              jsonb_build_object('accounting_document_id', accounting_document_id, 'payment_record_id', payment_record_id ) as docprjson

                            from accounting.accounting_document_payments_payment_record -- adppr
                            where payment_record_id = pr_id
                            union
                            select
                              adppr.accounting_document_id,
                              adppr.payment_record_id
                              ,
                              jsonb_build_object('accounting_document_id', adppr.accounting_document_id, 'payment_record_id', adppr.payment_record_id ) as docprjson
                            from accounting.accounting_document_payments_payment_record adppr
                            join docpr on
                            (	docpr.accounting_document_id = adppr.accounting_document_id
                              or
                              docpr.payment_record_id = adppr.payment_record_id
                            )
                          )
                          select
                            payment_record_id
                          from docpr
                        )
                      and pr.date <= NOW()::date
                      ) as line_volumes
                ) as grouplinked_payments_totals,
                *

            from
            (
                select distinct on (pr.id)
                pr.id as pr_id,
                pr.total as pr_total_amount,
                pr.reference_number as pr_reference_number,
                pr.reference_text as pr_reference_text,
                pr.date as pr_date,
                pr.name_other as pr_name_other,
                pr.account_other as pr_account_other,
                acc.iban__c as account_iban,
                acc.name as account_name,
                acc.firstname as account_firstname,
                acc.lastname as account_lastname,
                acc.billingstreet as account_billing_street,
                acc.billingpostalcode as account_billing_postal_code,
                acc.billingcity as account_billing_city,
                acc.billingcountry as account_billing_country,
                acc.shippingstreet as account_shipping_street,
                acc.shippingpostalcode as account_shipping_postal_code,
                acc.shippingcity as account_shipping_city,
                acc.shippingcountry as account_shipping_country,
                acc.emailforinvoices__c as account_email_for_invoices,
                acc.role as account_type,
                acc.id as account_sfid
                from payment.payment_record pr
                left join public.account acc on (
                    (
                      trim(replace(pr.account_other, ' ', '')) = trim(replace(acc.iban__c, ' ', ''))
                      and length(pr.account_other) > 0
                    ) or
                    (lower(trim(pr.name_other)) = lower(trim(acc.name)) and length(pr.name_other) > 0)
                ) and acc.parentid is null
                where true
                and pr.date <= NOW()::date
                group by pr.id, acc.iban__c, acc.name, acc.firstname, acc.lastname, acc.billingstreet, acc.billingpostalcode, acc.billingcity, acc.billingcountry, acc.shippingstreet, acc.role,
                acc.shippingpostalcode, acc.shippingcity, acc.shippingcountry, acc.emailforinvoices__c, acc.id

            ) as doc_payment
        ) as group_data

    ) as alldocbased
  `,
    })
], PaymentDocPaymentGroupsNowPaymentDates);
exports.PaymentDocPaymentGroupsNowPaymentDates = PaymentDocPaymentGroupsNowPaymentDates;
//# sourceMappingURL=materialized-payment_doc_payment_groups_now_payment_dates.js.map